import { HeaderText } from '@components/Layout/HeaderText';
import { Stack } from '@mui/material';
import { Download } from './Download';

type HeaderProps = {
  campaignName: string;
};

export const Header = (props: HeaderProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <HeaderText>{props.campaignName}</HeaderText>
      <Download campaignName={props.campaignName} />
    </Stack>
  );
};
